// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"build_node_index_js":"3c0ba3af8e5b6e83cb6d5bd18f3f96b382297b6f98a3c419ec4d0d04bec7f51f","node_modules_react_index_js":"7d7485f470234010ac1ac35604536f8ddc0956bd2335506d15e1168db6893246"}[chunkId] + ".js";
};